import apiClient from '../clienteFebosAPI';

const RESOURCE = '/v2/aprobaciones';

export const clTraysListV2 = (payload) => {
  const params = apiClient.queryParams(payload);

  return apiClient.get(`${RESOURCE}/ejecuciones?${params}`, {
    operacionId: 'io.trays.v2'
  });
};

export const clExecutionsListV2 = (payload) => {
  const params = apiClient.queryParams(payload);
  return apiClient.get(`${RESOURCE}/ejecuciones?${params}`);
};

export const sendToFlowMassive = (payload) => {
  const params = apiClient.queryParams(payload.params);

  return apiClient.post(`${RESOURCE}/ejecuciones/masiva?${params}`,
    payload.body, { operacionId: 'io.aprobaciones.ejecucion.masiva.crear' });
};

export const fileSignaturePerson = (payload) => apiClient.get(
    `${RESOURCE}/usuarios/personas`,
    {
      headers: {
        token: payload.token
      },
      operacionId: 'io.aprobaciones.persona.obtener'
    }
);

export const fileSignatureExternal = (payload) => apiClient.get(
  `${RESOURCE}/externas`,
  {
    headers: {
      Authorization: payload.token
    },
    operacionId: 'io.aprobaciones.externos.obtener'
  }
);
export const getInfoCUExternal = ({
  processId, action, domain, token
}) => apiClient.post(
  `${RESOURCE}/externas/firma/enrrolamiento`,
  {
    idProceso: processId,
  },
  {
    headers: {
      Authorization: token
    },
    params: {
      accion: action,
      dominioPortal: domain
    },
    operacionId: 'io.aprobaciones.externos.obtener'
  }
);

export const cuVerificationInfoExternal = (userData) => {
  const params = apiClient.queryParams(userData.params);
  return apiClient.post(`${RESOURCE}/externas/firma/enrrolamiento?${params}`, userData.body,
    {
      headers: userData.headers,
      operacionId: 'io.usuario.cu.verification.info'
    });
};

export const cuEsignCertifiedExternal = (userData) => {
  const params = apiClient.queryParams(userData.params);
  return apiClient.put(`${RESOURCE}/externas/firma/enrrolamiento/?${params}`, userData.body,
    {
      headers: userData.headers,
      operacionId: 'io.usuario.cu.certified.info'
    });
};

export const setSignIdExternal = ({ processId, token, signToken, OTP, documentId, signName }) => apiClient.post(
  `${RESOURCE}/externas/firma`,
  {
    idProceso: processId,
    signToken: signToken || undefined,
    OTP: OTP || undefined,
    documentId: documentId || undefined,
    signName: signName || undefined,
  },
  {
    headers: {
      Authorization: token,
      token: token
    },
    operacionId: 'io.aprobaciones.externos.obtener'
  }
);

export const signFileByPerson = (payload) => apiClient.post(
    `${RESOURCE}/usuarios/personas`,
    {
      otpId: payload.otpId,
      OTP: payload.otpCode
    },
    {
      headers: {
        token: payload.token
      },
      operacionId: 'io.aprobaciones.persona.firmar'
    }
);

export const requestOtpForSignature = (payload) => apiClient.post(
    `${RESOURCE}/ejecuciones/personas/otp`,
    {},
    {
      headers: {
        token: payload.token
      },
      operacionId: 'io.aprobaciones.persona.otp.solicitar'
    }
);

export const notifyExecution = (ejecucionId) => {
  const params = apiClient.queryParams({ ejecucionId });
  return apiClient.post(
    `${RESOURCE}/ejecuciones/${ejecucionId}/notificar?${params}`,
    {},
    { operacionId: 'io.aprobaciones.ejecucion.notificar' }
  );
};
